import APP_CONFIG from 'config';
import { useCallback } from 'react';

const useGoToTop = () => useCallback((smooth: boolean = false, element?: HTMLDivElement | null) => {
  const { scrollTop } = document.documentElement;
  let top = 0;
  if (element) {
    const { top: elementTop = 0 } = element.getBoundingClientRect();
    top = window.scrollY + elementTop;
  }
  if (window && scrollTop && scrollTop > APP_CONFIG.HEADER_HEIGHT) {
    window.scrollTo({
      top,
      behavior: smooth ? 'smooth' : undefined,
    });
  }
}, []);

export default useGoToTop;
